__turbopack_context__.v({
  "action-complete": "FreeOnboarding-module-scss-module__tAWoqq__action-complete",
  "addon-content-items": "FreeOnboarding-module-scss-module__tAWoqq__addon-content-items",
  "addon-content-text": "FreeOnboarding-module-scss-module__tAWoqq__addon-content-text",
  "addon-content-wrapper": "FreeOnboarding-module-scss-module__tAWoqq__addon-content-wrapper",
  "addon-description": "FreeOnboarding-module-scss-module__tAWoqq__addon-description",
  "content-item": "FreeOnboarding-module-scss-module__tAWoqq__content-item",
  "content-text": "FreeOnboarding-module-scss-module__tAWoqq__content-text",
  "content-wrapper": "FreeOnboarding-module-scss-module__tAWoqq__content-wrapper",
  "content-wrapper-copy-mask": "FreeOnboarding-module-scss-module__tAWoqq__content-wrapper-copy-mask",
  "content-wrapper-copy-mask-items": "FreeOnboarding-module-scss-module__tAWoqq__content-wrapper-copy-mask-items",
  "controls": "FreeOnboarding-module-scss-module__tAWoqq__controls",
  "copy-mask-arrow-element": "FreeOnboarding-module-scss-module__tAWoqq__copy-mask-arrow-element",
  "copy-mask-header": "FreeOnboarding-module-scss-module__tAWoqq__copy-mask-header",
  "customizable-part": "FreeOnboarding-module-scss-module__tAWoqq__customizable-part",
  "description": "FreeOnboarding-module-scss-module__tAWoqq__description",
  "domain": "FreeOnboarding-module-scss-module__tAWoqq__domain",
  "domain-example": "FreeOnboarding-module-scss-module__tAWoqq__domain-example",
  "generate-new-mask": "FreeOnboarding-module-scss-module__tAWoqq__generate-new-mask",
  "get-addon-button": "FreeOnboarding-module-scss-module__tAWoqq__get-addon-button",
  "go-to-dashboard-button": "FreeOnboarding-module-scss-module__tAWoqq__go-to-dashboard-button",
  "headline": "FreeOnboarding-module-scss-module__tAWoqq__headline",
  "hidden-mobile": "FreeOnboarding-module-scss-module__tAWoqq__hidden-mobile",
  "is-completed": "FreeOnboarding-module-scss-module__tAWoqq__is-completed",
  "label": "FreeOnboarding-module-scss-module__tAWoqq__label",
  "large-arrow": "FreeOnboarding-module-scss-module__tAWoqq__large-arrow",
  "mask-use": "FreeOnboarding-module-scss-module__tAWoqq__mask-use",
  "next-link": "FreeOnboarding-module-scss-module__tAWoqq__next-link",
  "onboarding": "FreeOnboarding-module-scss-module__tAWoqq__onboarding",
  "progress-container": "FreeOnboarding-module-scss-module__tAWoqq__progress-container",
  "reply-description": "FreeOnboarding-module-scss-module__tAWoqq__reply-description",
  "skip-link": "FreeOnboarding-module-scss-module__tAWoqq__skip-link",
  "small-arrow": "FreeOnboarding-module-scss-module__tAWoqq__small-arrow",
  "step": "FreeOnboarding-module-scss-module__tAWoqq__step",
  "step-addon": "FreeOnboarding-module-scss-module__tAWoqq__step-addon",
  "step-copy-mask": "FreeOnboarding-module-scss-module__tAWoqq__step-copy-mask",
  "step-custom-domain": "FreeOnboarding-module-scss-module__tAWoqq__step-custom-domain",
  "styled-progress-bar": "FreeOnboarding-module-scss-module__tAWoqq__styled-progress-bar",
  "subdomain-picker-heading": "FreeOnboarding-module-scss-module__tAWoqq__subdomain-picker-heading",
  "welcome-header": "FreeOnboarding-module-scss-module__tAWoqq__welcome-header",
});
